module.exports = __webpack_public_path__ + "img/argos.8d44f4ff.png";